module.exports = __webpack_public_path__ + "img/html_icon.66717a23.png";